import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';

const ElementType = typeof Element === 'undefined' ? function EmptyElement() {} : Element;

export default function Pagination({
  className,
  params,
  setParams,
  pageCount,
  inputSearch,
  activeFilters,
  resetScrollOnPageChange,
  scrollContainerRef,
}) {
  const getActivePageParams = () => (params.offset ? params.offset / params.limit : 0);
  const [activePage, setActivePage] = useState(getActivePageParams);

  useEffect(() => {
    if (inputSearch !== '' || activeFilters.length) {
      setActivePage(getActivePageParams());
    }
  }, [inputSearch, activeFilters]);
  useEffect(() => {
    setActivePage(getActivePageParams());
  }, [params.offset]);

  if (!pageCount) return null;

  return (
    <ReactPaginate
      breakLabel="..."
      pageCount={pageCount}
      marginPagesDisplayed={1}
      pageRangeDisplayed={2}
      onPageChange={({ selected }) => {
        if (resetScrollOnPageChange) {
          if (scrollContainerRef?.current) {
            scrollContainerRef.current.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          } else {
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }
        }

        setParams({ ...params, offset: selected * params.limit });
        setActivePage(selected);
      }}
      forcePage={activePage}
      containerClassName={`inline-flex flex-row items-center justify-center gap-3 py-0.5 px-2 w-full ${className}`}
      pageClassName="inline-flex items-center justify-center h-6 w-6 cursor-pointer font-secondary text-base font-medium text-gray-600"
      pageLinkClassName="inline-flex items-center justify-center h-6 w-6 rounded-full"
      activeClassName="!bg-primary-500 !text-white rounded-full"
      previousClassName="hidden"
      nextClassName="hidden"
      breakClassName="inline-flex items-center justify-center h-6 w-6 font-secondary text-base font-medium text-gray-600"
      initialPage={activePage}
    />
  );
}

Pagination.defaultProps = {
  className: '',
  inputSearch: '',
  activeFilters: [],
  resetScrollOnPageChange: false,
  scrollContainerRef: null,
};

Pagination.propTypes = {
  className: PropTypes.string,
  inputSearch: PropTypes.string,
  params: PropTypes.shape({
    offset: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
  }).isRequired,
  activeFilters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ),
  setParams: PropTypes.func.isRequired,
  pageCount: PropTypes.number.isRequired,
  resetScrollOnPageChange: PropTypes.bool,
  scrollContainerRef: PropTypes.shape({
    current: PropTypes.instanceOf(ElementType),
  }),
};
